import { render, staticRenderFns } from "./TeacherPage.vue?vue&type=template&id=2ce2119d&lang=pug&"
import script from "./TeacherPage.vue?vue&type=script&lang=js&"
export * from "./TeacherPage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports